
export const downloadFile = (headers, data) => {
    const fileName = headers['content-disposition'].split('filename=')[1];
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}